<template>
  <div id="home">
    <my-header></my-header>
    <div class="image-store height-auto">
      <img src="/static/images/cover.jpg" />
    </div>
    <div class="pd40">

      <div class="row mt40">
        <div class="col-md-5">
          <img src="/static/images/vung-trong.jpg"  class="border-radius-8 mb10" style="max-height:600px" />
        </div>
        <div class="col-md-7" v-if="post">
          <div v-html="post.description"></div>
          <router-link class="btn btn-success w-100" :to="{ name: 'FormRegisterPlanArea', params: { }}">Đăng ký vùng trồng</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import MyHeader from '@/components/Layout/Header'
import Loading from '@/components/elements/Loading'

export default {
  name: 'Home',
  components: {
    MyHeader,
    Loading
  },
  data () {
    return {
      user: null,
      post: null
    }
  },
  methods: {
    fetchPost () {
      Utils.requestV2(this, true)
        .get(`/posts?code=plan-area`)
        .then((response) => {
          console.log('response', response)
          if (response.data.length > 0) {
            this.post = response.data[0]
          }
        })
    }
  },

  mounted () {
    this.user = Utils.getUser(this)
    this.fetchPost()
  },
  beforeDestroy () {}
}
</script>



// WEBPACK FOOTER //
// src/components/Page/PlanArea.vue